
<template>
	<div class="clearfix">
		<compWrapper class="pull-left width-45per" title="权限菜单" theme="primary">
			<vTree
				style="overflow: auto;height: 320px;"
				@on-check-change="getPermissionIds"
				identifier="id"
				:data="authmenu"
				selection
				class="padding-10"
			></vTree>
		</compWrapper>
		<compWrapper class="pull-right width-45per" title="组织角色基本信息" theme="primary">
			<compFormEdit :formdata="getBase" v-model="formData" ref="form" class="margin-15" :rules="rules"></compFormEdit>
		</compWrapper>
		<footer class="pull-right text-right width-100per">
			<vButton theme="primary" class="margin-right-15" @click="submit">确认</vButton>
			<vButton @click="cancel">取消</vButton>
		</footer>
		<vLoading loading size="large" fix v-if="loading"></vLoading>
	</div>
</template>

<script>
import { HttpUpdateOrgrole, HttpOrgroleDetail, HttpConvertOrgroleAlias } from '@/service/ucadm';
import { mapGetters, mapState } from 'vuex';
export default {
	props: ['params'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit"),
	},
	data() {
		return {
			permissionIds: [],
			checkIds: [],
			formData: {
				name: "",
			},
			loading: false,
			rules: {
				displayName: [{
					required: true,
					message: "该信息不能为空,请填写"
				}]
			},
		};
	},
	mounted() {
		this.getRoleDetail();
	},
	computed: {
		...mapGetters('ucadm', ['getOrgRolePermenu']),
		...mapState(['userinfo']),
		isSuper() {
			return this.userinfo.isOps == 1 || this.userinfo.isSuper == 1;
		},
		isAdd() {
			return this.params.type === 'add'
		},
		authmenu() {
			const ids = this.checkIds || [];
			const data = this.getOrgRolePermenu.map(function (item) {
				return {
					title: item.title,
					id: item.id,
					parentId: item.parentId,
					selected: ids.some(function (id) {
						return id == item.id
					})
				}
			});
			const Nodes = [];
			data.forEach(item => {
				const parentId = item.parentId;
				if (!parentId) return Nodes.push(item);
				const parent = data.find(function (item) {
					return parentId === item.id;
				});
				if (!parent) return;
				const children = parent.children;
				if (children) {
					children.push(item);
				} else {
					parent.children = [item];
				}
			});
			Nodes.forEach((item) => {
				item.expand = true;
			})
			return Nodes;
		},
		getBase() {
			return [{
				label: '名称',
				key: 'displayName',
				required: true,
				span: 24,
			}, {
				label: '标识符:',
				key: 'name',
				span: 24,
				on: {
					'on-focus': this.convertRoleAlias
				},
			}, {
				label: '是否全局角色',
				tag: "vCheckBox",
				span: 24,
				key: 'isGlobal',
				props: {
					trueValue: 1,
					falseValue: 0,
					readonly: !this.isAdd,
				},
				show: !(!this.isSuper && this.isAdd)
			}, {
				label: '描述',
				tag: "vTextarea",
				span: 24,
				key: 'description'
			}
			]
		},
	},
	methods: {
		cancel() {
			this.$emit('on-close');
		},
		getPermissionIds(val, node, checked, indeterminate) {
			this.permissionIds = [...checked, ...indeterminate];
			console.log(this.permissionIds)
		},
		async submit() {
			let vaild = await this.$refs.form.validate();
			if (!vaild) return;
			this.loading = true;
			let formData = { ...this.formData, permissionIds: this.permissionIds.join(',') };
			if (this.params.type === 'edit') {
				formData.id = this.params.id;
			}
			let response = await HttpUpdateOrgrole(formData).catch(err => {
				this.$VMessage.error(err.message);
			});
			if (response) {
				this.$VMessage.success(response.message);
				this.$emit('on-close');
				this.$emit('on-update');
			}
			this.loading = false
		},
		async getRoleDetail() {
			if (this.params.type !== 'edit') return;
			this.loading = true;
			const response = await HttpOrgroleDetail({ id: this.params.id }).catch(err => {
				this.$VMessage.error(err.message);
			});
			if (response) {
				const { displayName, name, description } = response.data.entity || {};
				const isGlobal = response.data.isGlobal ? 1 : 0;
				this.formData = { displayName, name, description, isGlobal };
				this.checkIds = this.permissionIds = response.data.permissionIds || [];
			}
			this.loading = false;
		},
		async convertRoleAlias() {
			let displayName = this.formData.displayName
			if (!displayName || this.formData.name) return;
			let response = await HttpConvertOrgroleAlias({ displayName }).catch(err => {
				this.$VMessage.error(err.message);
			});
			if (response) {
				this.formData.name = response.data;
			}
		},

	},
};
</script>
